export enum Progress {
  NotStarted = 'Not Started',
  InProgress = 'In Progress',
  Completed = 'Completed'
}

export interface NoAvailableDealsMessageProps {
  isExplorer: boolean
}
